import { createFileRoute } from "@tanstack/react-router";
import CTASection from "./-components/CTASection";
import FAQSection from "./-components/FAQSection";
import FeaturesSection from "./-components/FeaturesSection";
import HeroSection from "./-components/HeroSection";
import HowItWorksSection from "./-components/HowItWorksSection";

export const Route = createFileRoute("/_public/")({
	component: LandingPage,
});

function LandingPage() {
	return (
		<div className="bg-base-100">
			<HeroSection />
			<FeaturesSection />
			<HowItWorksSection />
			<FAQSection />
			<CTASection />
		</div>
	);
}
